/** Labels fiscales AR — alineado a fiscal_routing / dashboard INVOICE_SUBTYPE_LABELS. */

export const COMPROBANTE_SUBTYPE_LABELS = {
  INVOICE: 'Factura',
  DEBITO: 'Nota de débito',
  CREDITO: 'Nota de crédito',
  OTROS: 'Otros',
};

function normalizeCodigoFactura(value) {
  const text = String(value ?? '').trim().replace(/^0+/, '');
  return text || '0';
}

export function classifyComprobanteSubtype(bedrock = {}) {
  const tipo = String(bedrock.tipo_documento || '').toLowerCase();
  const codigo = normalizeCodigoFactura(
    bedrock.codigo_factura ?? bedrock['codigo factura'],
  );

  if (codigo === '2' || /debito|débito/.test(tipo)) return 'DEBITO';
  if (codigo === '3' || /credito|crédito/.test(tipo)) return 'CREDITO';
  if (
    codigo === '1'
    || /^factura$/.test(tipo)
    || tipo === 'invoice'
    || tipo === 'invoices'
  ) {
    return 'INVOICE';
  }
  return 'OTROS';
}

export function formatComprobanteLabel(bedrock = {}) {
  const tipo = String(bedrock?.tipo_documento || '').trim();
  if (/nota de cr[eé]dito/i.test(tipo)) return 'Nota de crédito';
  if (/nota de d[eé]bito/i.test(tipo)) return 'Nota de débito';
  if (/^factura$/i.test(tipo)) return 'Factura';

  if (tipo) {
    return tipo
      .split(/\s+/)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }

  const subtype = classifyComprobanteSubtype(bedrock);
  return COMPROBANTE_SUBTYPE_LABELS[subtype] || 'Comprobante';
}

export function formatVoucherTitle(bedrock = {}, letter = '') {
  const label = formatComprobanteLabel(bedrock);
  const letra = String(letter || bedrock?.letra_documento || '')
    .trim()
    .toUpperCase();
  return letra ? `${label} ${letra}` : label;
}

/** Category (invoices) + fiscal subtype for upload queue / list badges. */
export function formatUploadQueueTypeLabel({ doc_type: docType, comprobante_label: fiscalLabel } = {}) {
  const category = (docType || '')
    .trim()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
  const fiscal = (fiscalLabel || '').trim();

  if (category && fiscal) return `${category} · ${fiscal}`;
  return fiscal || category || '';
}
